import type React from 'react';
import { type FunctionComponent, createContext } from 'react';

interface Props {
  experiments: string[];
  children: React.ReactNode;
}

export const ExperimentContext = createContext<string[]>([]);

export const ExperimentProvider: FunctionComponent<Props> = ({
  children,
  experiments,
}) => (
  <ExperimentContext.Provider value={experiments}>
    {children}
  </ExperimentContext.Provider>
);
